import { Button, CircularProgress, Grid } from "@material-ui/core";
import React, { useContext, useMemo, useState } from "react";
import EmailInputField from "../email-Input-Field";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { PageContext } from "../../configs";
import isEmpty from "lodash/isEmpty";
import PageDomain from "../../domain";

const TriggerOTPView = () => {
  const { t } = useTranslation();
  const { authAccount } = useSelector((state) => state.application);
  const {
    bypassTriggerOTP,
    setFormUIState,
    newEmailAddress,
    setRetryTimeout,
    setToken,
  } = useContext(PageContext);
  const [processing, setProcessing] = useState(false);
  const [emailFieldError, setEmailFieldError] = useState("");

  const emailAddress = useMemo(() => {
    return isEmpty(newEmailAddress) ? authAccount.email : newEmailAddress;
  }, [authAccount.email, newEmailAddress]);

  const onClickSubmit = () => {
    PageDomain.triggerOTP({
      emailAddress,
      bypassTriggerOTP,
      t,
      setFormUIState,
      setProcessing,
      setRetryTimeout,
      setToken,
      setEmailFieldError
    });
  };

  return (
    <Grid container direction="column" className="row-gap-16">
      <EmailInputField
        value={emailAddress}
        disabled={true}
        showChangeBtn={true}
        fieldError={emailFieldError}
      />
      <Button
        variant="contained"
        className="primary-button form-button"
        onClick={onClickSubmit}
        startIcon={processing && <CircularProgress size={14} color="inherit" />}
        disabled={processing}
      >
        {t("settingPage.getOTPCode")}
      </Button>
    </Grid>
  );
};

export default TriggerOTPView;
